import i18n, {default_lang} from '~/i18n'
import * as types from './mutation-types'
import {UrlServices} from "~/utils/url-manager";
import RequestHandler from "~/utils/request-handler";
import store from '~/store';
import axios from 'axios';
axios.defaults.withCredentials = true;

export const state = {
    lang: default_lang,
    is_check_user_login: false,
    is_user_logged_in: false,
    login_type: "public",
    user_permissions: [],
    teams_data: [],
    user_info: {},
    redirect_url: ""
}

export const mutations = {
    [types.SET_LANG] (state, payload) {
        i18n.locale = payload;
        state.lang = payload;
    },
    [types.SET_IS_LOGGED_IN] (state, payload) {
        state.is_user_logged_in = payload;
    },
    [types.SET_LOGIN_TYPE] (state, payload) {
        state.login_type = payload;
    },
    [types.SET_USER_PERMISSIONS] (state, payload) {
        state.user_permissions = payload;
    },
    [types.SET_IS_CHECK_USER_LOGIN] (state, payload) {
        state.is_check_user_login = payload;
    },
    [types.SET_TEAMS_DATA] (state, payload) {
        state.teams_data = payload;
    },
    [types.SET_USER_INFO] (state, payload) {
        state.user_info = payload;
    },
    [types.SET_REDIRECT_URL] (state, payload) {
        state.redirect_url = payload;
    }
}

export const actions = {
    async setLang({commit}, payload){
        if(payload){

            // handle moment locale
            let moment_locale = 'en';
            switch(payload) {
                case 'en':
                    break;
                case 'tc':
                    moment_locale = 'zh-tw';
                    break;
            }

            if (payload in i18n.messages) {
                commit(types.SET_LANG, payload)
            } else {
                try {
                    const res = await import(/* webpackChunkName: "lang-[request]" */`../locale/${payload}.json`)
                    i18n.setLocaleMessage(payload, res);
                    commit(types.SET_LANG, payload)
                }
                catch(e) {
                    console.log(e)
                }
            }

            window.getApp.$moment.locale(moment_locale);
        }
    },
    setIsLoggedIn({commit}, payload){
        if(payload){
            return new Promise((resolve, reject) => {
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_data_preload'}), {}, {
                    'success': function(data){
                        store.dispatch('setTeamsData', data['available_teams']).then();
                        store.dispatch('setUserInfo', data['user_info']).then();
                        store.dispatch('setUserPermissions', data['auth_ops']).then(() => {
                            commit(types.SET_IS_LOGGED_IN, payload);
                            resolve();
                        });
                    }
                });
            });
        }else{
            return new Promise((resolve, reject) => {
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_logout'}), {}, {
                    'success': function(data){
                        commit(types.SET_IS_LOGGED_IN, payload);
                        resolve();
                    }
                })
            });
        }

    },
    setLoginType({commit}, payload){
        commit(types.SET_LOGIN_TYPE, payload)
    },
    setUserPermissions({commit}, payload){
        commit(types.SET_USER_PERMISSIONS, payload)
    },
    setIsCheckUserLogin({commit}, payload){
        if(payload){
            return new Promise((resolve, reject) => {
                axios.get(UrlServices.createUrl({'name': 'api_login_check'})).then((response) => {
                    let data = response.data;
                    if(data.result === 'success'){
                        store.dispatch('setIsLoggedIn', true).then(() => {
                            commit(types.SET_IS_CHECK_USER_LOGIN, payload);
                            resolve();
                        });
                    } else {
                        commit(types.SET_IS_CHECK_USER_LOGIN, payload);
                        resolve();
                    }

                });
            });
        }else{
            commit(types.SET_IS_CHECK_USER_LOGIN, payload);
        }
    },
    setTeamsData({commit}, payload){
        commit(types.SET_TEAMS_DATA, payload)
    },
    setUserInfo({commit}, payload){
        commit(types.SET_USER_INFO, payload)
    },
    setRedirectUrl({commit}, payload) {
        commit((types.SET_REDIRECT_URL), payload);
    }
}